import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import FoodCard from "./food-card";

const artists = [
  {
    name: "Pizza Geeks",
    sort: "Pizza Geeks",
    link: "https://www.instagram.com/pizza_geeks",
    img: "pizza.jpg",
  },
  {
    name: "El Dorado Taqueria",
    sort: "El Dorado Taqueria",
    link: "https://www.instagram.com/eldoradotaqueriaedinburgh",
    img: "eld.jpg",
  },
  {
    name: "The Tuskers",
    sort: "Tuskers",
    link: "https://www.instagram.com/the.tuskers",
    img: "tusk.jpeg",
  },
];

const sortedArtists = artists.sort((a, b) => a.sort.localeCompare(b.sort));

function Food() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <Box
        sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}
        className="lineup-border"
      >
        {sortedArtists.map((artist) => (
          <FoodCard key={artist.name} artist={artist} />
        ))}
      </Box>
    </Container>
  );
}
export default Food;
